<template>
  <button @click="login"><slot></slot></button>
</template>

<script>
  /**
   * @see https://github.com/AzureAD/azure-activedirectory-library-for-js
   */

  import { AuthenticationContext, location } from 'window'
  import env from '@/lib/env'

  export default {
    data () {
      return {
        token: null
      }
    },
    computed: {
      signInOptions () {
        return {
          clientId: env('OFFICE_CLIENT_ID'),
          tenant: 'common',
          redirectUri: `https://${location.host}/login#microsoft-auth-redirect`,
          navigateToLoginRequestUrl: false,
          callback: this.handleSignIn
        }
      }
    },
    mounted () {
      this.$_authenticationContext = new AuthenticationContext(this.signInOptions)

      if (
        !this.$route.query.hasOwnProperty('google-auth-redirect') &&
        this.$_authenticationContext.isCallback(window.location.hash)) {
        this.$_authenticationContext.handleWindowCallback()
      }
    },
    methods: {
      login () {
        this.$_authenticationContext.login()
      },
      handleSignIn (errorDesc, idToken, error) {
        if (error) {
          this.$emit('error', `[${errorDesc}]: ${error}`)
          return
        }

        this.token = idToken
        this.$_authenticationContext.getUser(this.handleUser)
      },
      handleUser (error, user) {
        if (error) {
          this.$emit('error', `[login]: ${error}`)
          return
        }

        this.$emit('success', {
          email: user.userName,
          token: this.token
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// office-sign-in-button.vue?106f0de8